'use client';

import { useState, useEffect } from 'react';
import ProductCard, { Product } from './ProductCard';
import QuickViewModal from './QuickViewModal';

interface ProductsInteractiveProps {
  products: Product[];
  currentLang?: 'sl' | 'en';
}

export default function ProductsInteractive({
  products,
  currentLang = 'sl',
}: ProductsInteractiveProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('Med');
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [quickViewProduct, setQuickViewProduct] = useState<Product | null>(null);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const categories = [
    // { id: 'all', label: currentLang === 'sl' ? 'Vse' : 'All' },
    { id: 'Med', label: currentLang === 'sl' ? 'Med' : 'Honey' },
    // { id: 'Cvetni prah', label: currentLang === 'sl' ? 'Cvetni prah' : 'Pollen' },
    // { id: 'Medeni liker', label: currentLang === 'sl' ? 'Medeni liker' : 'Honey Liqueur' },
    // { id: 'Ostali', label: currentLang === 'sl' ? 'Ostali' : 'Other' },
  ];

  const handleCategoryChange = (categoryId: string) => {
    setIsTransitioning(true);
    setSelectedCategory(categoryId);

    setTimeout(() => {
      if (categoryId === 'all') {
        setFilteredProducts(products);
      } else {
        setFilteredProducts(products.filter((p) => p.category === categoryId));
      }
      setIsTransitioning(false);
    }, 300);
  };

  const handleQuickView = (product: Product) => {
    setQuickViewProduct(product);
  };

  const handleCloseQuickView = () => {
    setQuickViewProduct(null);
  };

  if (!isHydrated) {
    return (
      <div className="grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-3">
          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-12 bg-muted rounded-lg animate-pulse"></div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-9">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="space-y-4">
                <div className="aspect-[4/5] bg-muted rounded-[2rem] animate-pulse"></div>
                <div className="h-6 bg-muted rounded animate-pulse"></div>
                <div className="h-4 bg-muted rounded animate-pulse w-3/4"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="grid lg:grid-cols-12 gap-8">
        {/* Sidebar Filters */}
        <div className="lg:col-span-3">
          <div className="sticky top-32 space-y-2">
            <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-4">
              {currentLang === 'sl' ? 'Kategorije' : 'Categories'}
            </p>
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => handleCategoryChange(category.id)}
                className={`w-full text-left px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                  selectedCategory === category.id
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-muted text-foreground hover:bg-muted/80'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>

        {/* Product Grid */}
        <div className="lg:col-span-9">
          <div
            className={`grid md:grid-cols-2 lg:grid-cols-3 gap-6 transition-opacity duration-300 ${
              isTransitioning ? 'opacity-0' : 'opacity-100'
            }`}
          >
            {filteredProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onQuickView={handleQuickView}
                currentLang={currentLang}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Quick View Modal */}
      <QuickViewModal
        product={quickViewProduct}
        onClose={handleCloseQuickView}
        currentLang={currentLang}
      />
    </>
  );
}
